import { render } from "./RenderedElementCode.vue?vue&type=template&id=cadd6e4a"
import script from "./RenderedElementCode.vue?vue&type=script&lang=js"
export * from "./RenderedElementCode.vue?vue&type=script&lang=js"

import "./RenderedElementCode.vue?vue&type=style&index=0&id=cadd6e4a&lang=scss"

import exportComponent from "C:\\Users\\Callum\\Desktop\\k1890584_watkins_callum_code\\mo-books\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__